import * as z from "zod";

export const unassignSendcloudContract = {
  name: "unassignSendcloudContract" as const,
  input: z.object({ redoCarrierAccountId: z.string() }),
  output: z.object({}),
};
